import React from "react";
import flairLogo from "../../images/flair_airlines_logo_white.svg";

import "./footer.scss";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFacebookF, faInstagram, faXTwitter } from "@fortawesome/free-brands-svg-icons";
import { useTranslation } from 'react-i18next';

function Footer() {
  const { t } = useTranslation();

  const footerLinks = [
    {
      label: "login",
      items: [
        {
          label: "Travel Agent",
          link: "",
        },
        {
          label: "Check In",
          link: "",
        },
        {
          label: "Sustainability",
          link: "",
        },
      ],
    },
    {
      label: "top destinations",
      items: [
        {
          label: "Flights to Cancun",
          link: "",
        },
        {
          label: "Flights to Puerto Vallarta",
          link: "",
        },
        {
          label: "Flights to Punta Cana",
          link: "",
        },
        {
          label: "Flights to Orlando",
          link: "",
        },
        {
          label: "Flights to Fort Lauderdale",
          link: "",
        },
        {
          label: "Flights to Las Vegas",
          link: "",
        },
        {
          label: "Flights to Phoenix",
          link: "",
        },
      ],
    },
    {
      label: "trending routes",
      items: [
        {
          label: "Edmonton - Cancun",
          link: "",
        },
        {
          label: "Winnipeg - Las Vegas",
          link: "",
        },
        {
          label: "Waterloo - Puerto Vallarta",
          link: "",
        },
        {
          label: "Flights to Orlando",
          link: "",
        },
        {
          label: "London - Orlando",
          link: "",
        },
        {
          label: "Montreal - Cancun",
          link: "",
        },
        {
          label: "Toronto - Punta Cana",
          link: "",
        },
        {
          label: "Vancouver - Phoenix",
          link: "",
        },
      ],
    },
    {
      label: "legal notice",
      items: [
        {
          label: "Optional Fees",
          link: "",
        },
        {
          label: "Privacy Policy",
          link: "",
        },
        {
          label: "Terms of Use",
          link: "",
        },
        {
          label: "Reservation Terms & Conditions",
          link: "",
        },
        {
          label: "Passenger Protection Regulations",
          link: "",
        },
        {
          label: "US Tarmac Delay Plan",
          link: "",
        },
        {
          label: "US Customer Service Plan",
          link: "",
        },
        {
          label: "Responsible Governance",
          link: "",
        },
        {
          label: "Accessible Services",
          link: "",
        },
      ],
    },
    {
      label: "contact us",
      items: [
        {
          label: "Contact Us",
          link: "",
        },
        {
          label: "Flight Status",
          link: "",
        },
        {
          label: "Newsletter",
          link: "",
        },
        {
          label: "Group Travel",
          link: "",
        },
        {
          label: "Careers",
          link: "",
        },
        {
          label: "Flair Cadet Program",
          link: "",
        },
        {
          label: "Pilot Careers",
          link: "",
        },
        {
          label: "About Us",
          link: "",
        },
        {
          label: "News & Media Centre",
          link: "",
        },
      ],
    },
  ];
  return (
    <div className="footer-container display-none-mobile">
      <div className="footer-container__wrapper">
        <div className="logo">
          <a href="https://flyflair.com/" title="Flair Airlines Logo">
            <img
              src={flairLogo}
              alt="Flair Airlines Logo"
              className="logo-image"
            />
          </a>
        </div>

        {/* <div className="links">
          {footerLinks.map((linkItem) => (
            <ul className="links__section">
              <span className="links__heading">{linkItem.label}</span>
              {linkItem.items.map((item) => (
                <li>{item.label}</li>
              ))}
            </ul>
          ))}
        </div> */}
      </div>

      {/* <div className="socials">
        <FontAwesomeIcon icon={faInstagram} className="icon-backdrop" />
        <FontAwesomeIcon icon={faFacebookF} className="icon-backdrop" />
        <FontAwesomeIcon icon={faXTwitter} className="icon-backdrop" />

      </div> */}
      <div className="copyright">
      <div className="footer">
          <div className="footer-name">
            <p>Flair Airlines</p>
            <p>© Flair Airlines 2025</p>
          </div>

          <p className='customer-support-text'>
            {t('customer_support')}
           
              <a
                href='tel:+18337112333'
                className='customer-support-link'
              >
                1-833-711-2333
              </a>
            {' | '}
            {t('hours_of_operation')}
          </p>

        <div className="disclaimer">
          <p>{t('fares_displayed_have_been_collected_within_the_last_24_hrs_and_may_no_longer_be_available_at_time_of_booking_fares_are_one_way_non_refundable_taxes_and_fees_included')}</p>
          <p>
            <a className="disclaimer-links" href="https://flyflair.com/travel-info/optional-fees"> {t('additional_fees_and_charges_for_optional_products_and_services_may_apply')}</a>
            {t('limited_seats_available_for_a_limited_time')}
            <a className="disclaimer-links" href="https://flyflair.com/reservation-terms-conditions">{t('conditions_apply')}</a>
            </p>
        </div>

        </div>
      </div>
    </div>
  );
}

export default Footer;
